var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBackToTopArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  preserveAspectRatio: "none",
  overflow: "visible",
  style: {
    display: "block"
  },
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Icon / Arrow_Up_LG"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M12 21V3M17 8L12 3L7 8",
  stroke: "white",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))));
export default SvgBackToTopArrow;